(function () {
  'use strict';

  var ROOT = document.getElementById('gg-floating-menu-root');
  if (!ROOT) return;

  var TOGGLE       = document.getElementById('ggMenuToggle');
  var SIDEBAR      = document.getElementById('ggSidebarMenu');
  var OVERLAY      = document.getElementById('ggSidebarOverlay');
  var CLOSE_BTN    = document.getElementById('ggSidebarClose');
  var SEARCH_INPUT = document.getElementById('ggSidebarSearchInput');
  var SEARCH_FORM  = document.getElementById('ggSidebarSearchForm');
  var CLEAR_BTN    = document.getElementById('ggSearchClear');
  var RESULTS_BOX  = document.getElementById('ggPredictiveSearchResults');
  var RESULTS_LIST = document.getElementById('ggPredictiveSearchList');
  var STATE_LABEL  = document.getElementById('ggPredictiveSearchState');
  var CART_COUNT   = document.getElementById('ggSidebarCartCount');

  /* ── Prix : l'API retourne price_min en centimes (ex: 490 = 4,90€) ── */
function formatPrice(cents) {
    if (cents == null || cents === '') return '';
    var n = parseFloat(cents);
    if (isNaN(n)) return '';
    // L'API retourne parfois en centimes (490) parfois en euros (4.90)
    // Si n >= 1 et pas de décimales significatives > 2 → c'est des centimes
    // Heuristique fiable : si n > 20 → centimes, sinon → euros déjà
    var euros = n > 20 ? n / 100 : n;
    return euros.toFixed(2).replace('.', ',') + '\u00a0€';
  }


  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function(c) {
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c];
    });
  }

  /* ── Toggle scroll ── */
  var ticking = false;
  window.addEventListener('scroll', function() {
    if (!ticking) {
      requestAnimationFrame(function() {
        if (TOGGLE) TOGGLE.classList.toggle('is-visible', window.scrollY > 60);
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });
  if (TOGGLE) TOGGLE.classList.toggle('is-visible', window.scrollY > 60);

  /* ── Open/Close ── */
  var lastFocused = null;

  function openSidebar() {
    lastFocused = document.activeElement;
    SIDEBAR.classList.add('is-open');
    SIDEBAR.setAttribute('aria-hidden', 'false');
    OVERLAY.classList.add('is-visible');
    document.body.classList.add('gg-sidebar-open');
    document.body.style.overflow = 'hidden';
    if (TOGGLE) TOGGLE.setAttribute('aria-expanded', 'true');
    refreshCartCount();
    setTimeout(function() { if (CLOSE_BTN) CLOSE_BTN.focus(); }, 80);
  }

  function closeSidebar() {
    SIDEBAR.classList.remove('is-open');
    SIDEBAR.setAttribute('aria-hidden', 'true');
    OVERLAY.classList.remove('is-visible');
    document.body.classList.remove('gg-sidebar-open');
    document.body.style.overflow = '';
    if (TOGGLE) TOGGLE.setAttribute('aria-expanded', 'false');
    hideResults();
    if (lastFocused) setTimeout(function() { lastFocused.focus(); }, 80);
  }

  if (TOGGLE)    TOGGLE.addEventListener('click', openSidebar);
  if (CLOSE_BTN) CLOSE_BTN.addEventListener('click', closeSidebar);
  if (OVERLAY)   OVERLAY.addEventListener('click', closeSidebar);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.body.classList.contains('gg-sidebar-open')) closeSidebar();
  });

  /* ── Accordion ── */
  document.querySelectorAll('.gg-sidebar__submenu-toggle').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var group = btn.closest('.gg-sidebar__group');
      if (!group) return;
      var opening = !group.classList.contains('is-open');
      document.querySelectorAll('.gg-sidebar__group.is-open').forEach(function(g) {
        g.classList.remove('is-open');
        var t = g.querySelector('.gg-sidebar__submenu-toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
      if (opening) {
        group.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  /* ── Recherche ── */
  var searchTimer = null;
  var currentCtrl = null;

  function showResults() {
    if (RESULTS_BOX) RESULTS_BOX.removeAttribute('hidden');
  }
  function hideResults() {
    if (RESULTS_BOX) RESULTS_BOX.setAttribute('hidden', '');
    if (SEARCH_INPUT) SEARCH_INPUT.setAttribute('aria-expanded', 'false');
  }
  function setLabel(t) { if (STATE_LABEL) STATE_LABEL.textContent = t; }

  function renderLoading() {
    if (!RESULTS_LIST) return;
    RESULTS_LIST.innerHTML = '<div class="gg-predictive-search__loading">Recherche en cours</div>';
    setLabel('Chargement...');
    showResults();
  }

  function renderEmpty(q) {
    if (!RESULTS_LIST) return;
    RESULTS_LIST.innerHTML = '<div class="gg-predictive-search__empty">Aucun résultat pour « ' + esc(q) + ' »</div>';
    setLabel('Aucun résultat');
    showResults();
  }

  function buildItem(p) {
    /* Prix depuis price_min — toujours en centimes dans l'API Shopify */
    var priceHTML = p.price_min != null ? formatPrice(p.price_min) : '';
    var cmpHTML   = (p.compare_at_price_min && parseInt(p.compare_at_price_min,10) > parseInt(p.price_min,10))
      ? '<span class="gg-predictive-item__compare-price">' + formatPrice(p.compare_at_price_min) + '</span>' : '';

    /* Disponibilité */
    var available = p.available !== false;
    var badgeHTML = available
      ? '<span class="gg-predictive-item__badge gg-predictive-item__badge--available">Disponible</span>'
      : '<span class="gg-predictive-item__badge gg-predictive-item__badge--unavailable">Épuisé</span>';

    /* Image */
    var imgSrc = '', imgAlt = esc(p.title);
    if (p.featured_image) {
      imgSrc = typeof p.featured_image === 'string' ? p.featured_image : (p.featured_image.url || '');
      if (imgSrc && imgSrc.indexOf('cdn.shopify.com') !== -1) {
        imgSrc = imgSrc.replace(/(\.[a-z]+)(\?|$)/, '_100x100$1$2');
      }
      imgAlt = esc((p.featured_image.alt) || p.title);
    }
    var imgHTML = imgSrc
      ? '<img class="gg-predictive-item__image" src="' + esc(imgSrc) + '" alt="' + imgAlt + '" width="56" height="56" loading="lazy">'
      : '<div class="gg-predictive-item__image-placeholder"><svg viewBox="0 0 24 24" width="20" height="20"><path d="M21 19V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2ZM8.5 13.5l2.5 3 3.5-4.5 4.5 6H5l3.5-4.5Z" fill="currentColor"/></svg></div>';

    /* Variant */
    var variants = p.variants || [];
    var variant  = variants[0] || null;
    var vid      = variant ? variant.id : null;
    var url      = p.url || ('/products/' + (p.handle || ''));

    var addBtn = true
      ? '<button class="gg-predictive-item__btn gg-predictive-item__btn--add" type="button"'
        + ' data-gg-add-to-cart data-variant-id="' + esc(String(vid)) + '"'
        + ' data-product-title="' + esc(p.title) + '"'
        + ' data-product-price="' + esc(priceHTML) + '"'
        + ' data-product-image="' + esc(imgSrc) + '">'
        + '<svg viewBox="0 0 24 24" width="10" height="10"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg>'
        + ' Ajouter</button>'
      : '';

    return '<div class="gg-predictive-item">'
      + '<div class="gg-predictive-item__image-wrap">' + imgHTML + '</div>'
      + '<div class="gg-predictive-item__body">'
      + '<a href="' + esc(url) + '" class="gg-predictive-item__title">' + esc(p.title) + '</a>'
      + '<div class="gg-predictive-item__meta"><span class="gg-predictive-item__price">' + priceHTML + '</span>' + cmpHTML + badgeHTML + '</div>'
      + '<div class="gg-predictive-item__actions">'
      + '<a href="' + esc(url) + '" class="gg-predictive-item__btn gg-predictive-item__btn--view">Voir</a>'
      + addBtn + '</div></div></div>';
  }

  function renderResults(products, q) {
    if (!RESULTS_LIST) return;
    if (!products || !products.length) { renderEmpty(q); return; }
    setLabel(products.length + ' résultat' + (products.length > 1 ? 's' : ''));
    RESULTS_LIST.innerHTML = products.map(buildItem).join('');
    RESULTS_LIST.querySelectorAll('[data-gg-add-to-cart]').forEach(function(btn) {
      btn.addEventListener('click', handleAddToCart);
    });
  }

  function doSearch(q) {
    if (currentCtrl) { try { currentCtrl.abort(); } catch(e){} }
    currentCtrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    renderLoading();
    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product&resources[limit]=5'
      + '&resources[options][unavailable_products]=show'
      + '&resources[options][fields]=title,product_type,variants.title,vendor';
    var opts = { headers: { 'Accept': 'application/json' } };
    if (currentCtrl) opts.signal = currentCtrl.signal;
    fetch(url, opts)
      .then(function(r) { if (!r.ok) throw new Error(); return r.json(); })
      .then(function(data) {
        currentCtrl = null;
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, q);
      })
      .catch(function(e) {
        currentCtrl = null;
        if (e && e.name === 'AbortError') return;
        renderEmpty(q);
      });
  }

  if (SEARCH_INPUT) {
    SEARCH_INPUT.addEventListener('input', function() {
      var q = SEARCH_INPUT.value.trim();
      if (CLEAR_BTN) CLEAR_BTN.hidden = !q;
      clearTimeout(searchTimer);
      if (!q) { hideResults(); return; }
      searchTimer = setTimeout(function() { doSearch(q); }, 300);
    });
  }
  if (CLEAR_BTN) {
    CLEAR_BTN.addEventListener('click', function() {
      if (SEARCH_INPUT) { SEARCH_INPUT.value = ''; SEARCH_INPUT.focus(); }
      CLEAR_BTN.hidden = true;
      hideResults();
    });
  }
  if (SEARCH_FORM) {
    SEARCH_FORM.addEventListener('submit', function() { hideResults(); });
  }

  /* ── Ajout panier ── */
  function handleAddToCart(e) {
    var btn = e.currentTarget;
    var vid = btn.dataset.variantId;
    if (!vid || btn.disabled) return;

    btn.classList.add('is-loading');
    btn.disabled = true;

    var fallback = {
      title: btn.dataset.productTitle || '',
      price: btn.dataset.productPrice || '',
      image: btn.dataset.productImage || ''
    };

    var addPromise = window.GGCartCore && typeof window.GGCartCore.addItem === 'function'
      ? window.GGCartCore.addItem(vid, 1, fallback)
      : fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
        }).then(function (r) { if (!r.ok) throw new Error(); return r.json(); });

    addPromise
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        btn.textContent = '✓ Ajouté';
        refreshCartCount();
        setTimeout(function() {
          btn.classList.remove('is-success');
          btn.disabled = false;
          btn.innerHTML = '<svg viewBox="0 0 24 24" width="10" height="10"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg> Ajouter';
        }, 2500);
      })
      .catch(function() {
        btn.classList.remove('is-loading');
        btn.disabled = false;
        btn.textContent = 'Erreur';
        setTimeout(function() {
          btn.innerHTML = '<svg viewBox="0 0 24 24" width="10" height="10"><path d="M12 5v14M5 12h14" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/></svg> Ajouter';
        }, 2000);
      });
  }

  /* ── Badge panier ── */
  function updateCartBadge() {
    if (window.GGCartCore && typeof window.GGCartCore.sync === 'function') {
      return window.GGCartCore.sync('sidebar').then(function(cart) {
        var count = (cart && cart.item_count) || 0;
        if (CART_COUNT) CART_COUNT.textContent = count > 0 ? count : '';
        return cart;
      }).catch(function() {});
    }

    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var count = cart.item_count || 0;
        if (CART_COUNT) CART_COUNT.textContent = count > 0 ? count : '';
        return cart;
      }).catch(function(){});
  }

  function refreshCartCount() {
    if (window.GGCartCore && typeof window.GGCartCore.getCount === 'function') {
      var current = window.GGCartCore.getCount();
      if (CART_COUNT) CART_COUNT.textContent = current > 0 ? current : '';
    }
    updateCartBadge();
  }
  document.addEventListener('cart:item-added', updateCartBadge);
  document.addEventListener('ggcart:updated', function (event) {
    var nextCount = event && event.detail ? (event.detail.count || 0) : 0;
    if (CART_COUNT) CART_COUNT.textContent = nextCount > 0 ? nextCount : '';
  });

})();
